import { render, staticRenderFns } from "./ListarCartorios.vue?vue&type=template&id=f7b47a5e"
import script from "./ListarCartorios.vue?vue&type=script&lang=js"
export * from "./ListarCartorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7b47a5e')) {
      api.createRecord('f7b47a5e', component.options)
    } else {
      api.reload('f7b47a5e', component.options)
    }
    module.hot.accept("./ListarCartorios.vue?vue&type=template&id=f7b47a5e", function () {
      api.rerender('f7b47a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ListarCartorios.vue"
export default component.exports